// passwordPolicy.ts — the ONE place the password rule lives (Wave D, Mockup 3).
// ResetPassword and Account previously each hardcoded their own 8-char rule.

export const PASSWORD_MIN_LENGTH = 8;

/** Human-readable inline policy note for form labels. */
export const PASSWORD_POLICY_NOTE = `at least ${PASSWORD_MIN_LENGTH} characters`;

/** Returns an error message, or null when the password passes the policy. */
export function passwordPolicyError(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH)
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  return null;
}
